import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

export const MyMDropDownList = (props) => {
  const { options, sx, needsBlank, blankValue, ...other } = props;

  return (
    <Select
      sx={{
        height: 40,
        ...sx
      }}
      {...other}
    >
      {needsBlank && <MenuItem sx={{ height: 30, }} key={-1} value=''>{blankValue ?? ''}</MenuItem>}
      {options.map((option) => {
        const isKeyValue = option.Key !== undefined;
        return (
          <MenuItem
            key={isKeyValue ? option.Key : option.value}
            value={isKeyValue ? option.Key : option.value}>
            {isKeyValue ? option.Value : option.text}
          </MenuItem>)
      })
      }
    </Select>
  );
};